import { useQuery } from '@tanstack/react-query';
import { useAuthStore } from '@/shared/model';
import { fetchTeamOpsRoster, getTeams, getMyTeams } from '../api/teamApi';
import { teamKeys } from './teamKeys';

export const useTeams = () => {
  return useQuery({
    queryKey: teamKeys.lists(),
    queryFn: getTeams,
    staleTime: 30_000,
  });
};

export const useMyTeams = () => {
  // 로그인 전 마운트 시 401 콘솔 에러 방지 — 인증 완료 후에만 호출.
  const isAuthed = useAuthStore((st) => !!st.user);
  return useQuery({
    queryKey: teamKeys.myTeams(),
    queryFn: getMyTeams,
    staleTime: 30_000,
    enabled: isAuthed,
  });
};

export const useTeamOpsRoster = () => {
  const isAuthed = useAuthStore((st) => !!st.user);
  return useQuery({
    queryKey: teamKeys.teamOpsRoster(),
    queryFn: fetchTeamOpsRoster,
    staleTime: 30_000,
    enabled: isAuthed,
  });
};
